import React from 'react';
import headerMock from '../../assets/images/header_mock.png';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const GratuitousProgramsLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="w-full">
        <div className="w-full flex flex-col">

          <div className="w-full bg-[#E2E9F1] flex justify-center items-end overflow-hidden">
            <div className="w-full max-w-[1440px] h-full flex items-end justify-center px-4">
              <img
                src={headerMock}
                alt="Заголовок Энергия"
                className="w-full h-full object-contain object-bottom"
              />
            </div>
          </div>

          <div className="h-4 w-full bg-[#0B508B]"></div>
        </div>
      </header>

      <main className="flex-grow w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {children}
      </main>

      <Footer />

    </div>
  );
};

export default GratuitousProgramsLayout;